import { RawCompanyData } from '@company/const';
import { CompanyActions } from '../actions';

export const initialState: RawCompanyData = undefined;

export function saveCompanyReducer(
  state = initialState,
  action: CompanyActions.SaveUnaddedCompany | CompanyActions.SyncSavedCompanyState | CompanyActions.ResetSavedCompany,
): RawCompanyData {
  switch (action.type) {
    case CompanyActions.SYNC_SAVED_COMPANY_STATE:
    case CompanyActions.SAVE_UNADDED_COMPANY: {
      return action.payload;
    }

    case CompanyActions.RESET_SAVED_COMPANY: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
